import { LIST_DEALS_FAILURE, LIST_DEALS_REQUEST, LIST_DEALS_SUCCESS } from "../../../actions/opportunities/increaseDealSizeActions/listDealsActions";

  const initialState = {
    listDealsLoading: false,
    listDealsData: [],
    listDealsError: null,
  };
  
  const listDealsReducer = (state = initialState, action) => {
    switch (action.type) {
      case LIST_DEALS_REQUEST:
        return { ...state, listDealsLoading: true , payload: action.payload};
      case LIST_DEALS_SUCCESS:
        return { ...state, listDealsLoading: false, listDealsData: action.payload };
      case LIST_DEALS_FAILURE:
        return { ...state, listDealsLoading: false, listDealsError: action.payload };       
      default:
        return state;
    }
  };
  
  export default listDealsReducer;
  